/**
 * @module Constants/successMessages
 * */

/**
 * @const {String} - Сохранено
 * */
export const SAVED = 'Сохранено'

export default {
  SAVED
}
